<template>
    <div class="login-form-header">
                 <h2>{{ headerTitle }}</h2>
                 <!-- <h6> <a @click="actionClicked">{{headerTitle.secondary }} </a></h6> -->
              </div>
</template>
<script>
export default {
    name: 'FormHeader',
    props: {
        isSignUp: {
            type: Boolean,
            default: false
        },
        headerTitle: {
            type: String,
            default: 'Login'
        }
    },
    data () {
        return {
           
            
        }
    },
    methods: {
        actionClicked() {
            if(this.isSignUp) {
                this.$emit('login');
            } else {
                this.$emit('signUp');
                
            }
        }
    }
}
</script>